// src/components/common/ECharts.jsx
import React, { useEffect, useRef } from "react";
import * as echarts from "echarts";

/**
 * ECharts 封装组件，自动合并 DataView 样式以在暗色主题下可见
 * @param {Object} props
 * @param {Object} props.option - ECharts 配置项
 * @param {string} [props.theme] - 图表主题 (默认 'dark')
 * @param {Object} [props.style] - 容器行内样式
 * @param {string} [props.className] - 容器类名
 */
export default function ECharts({
  option,
  type,
  theme = "dark",
  style = {},
  className = "",
}) {
  const chartRef = useRef(null);
  const instanceRef = useRef(null);

  useEffect(() => {
    if (!chartRef.current) return;
    // 初始化图表
    instanceRef.current = echarts.init(chartRef.current, theme);
    // 合并 DataView 样式，保证在暗色主题下可见
    const mergedOption = {
      ...option,
      title: { show: false },
      legend: [3, 8, 10].includes(type)
        ? {
            orient: "horizontal",
            top: 15, // 置頂
            left: "center",
            textStyle: { color: "#fff" },
          }
        : {
            orient: "horizontal",
            bottom: 0, // 原本的靠下
            left: "center",
            textStyle: { color: "#fff" },
          },
      toolbox: { show: false },
    };
    instanceRef?.current?.setOption(mergedOption);

    const resizeHandler = () => instanceRef.current?.resize();
    window.addEventListener("resize", resizeHandler);

    return () => {
      window.removeEventListener("resize", resizeHandler);
      instanceRef.current?.dispose();
    };
  }, [option, theme, type]);

  return (
    <div
      ref={chartRef}
      className={className}
      style={{
        width: "100%",
        height: "100%",
        position: "relative",
        ...style,
      }}
    />
  );
}
